import React, { useState, useRef } from "react";
import { createServico } from "../../../services/ServicoService";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

export const ServicoForm = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const inputPrice = useRef("");
  const inputName = useRef("");
  const [loading, setLoading] = useState(false);
  const [remarketing, setRemarketing] = useState(false);
  const inputSendRemarketingInDays = useRef("");
  const inputRemarketingMessage = useRef("");
  
  const history = useHistory();
  const toggle = () => setIsOpen(!isOpen);

  function handleSubmit(e) {
    setLoading(true);
    e.preventDefault();

    const data = {
      companyDocumentNumber: localStorage.getItem("companyDocumentNumber"),
      price: parseFloat(inputPrice.current.value || 0),
      name: inputName.current.value,
      estimatedDays: 0,
      estimatedMinutes: 0,
      cost: 0, // Mantido como 0 para manter compatibilidade com o banco/API
    };

    createServico(data)
      .then((response) => {
        props.listServicos(false);
        setIsOpen(false);
        toast.success("Serviço adicionado");
        setLoading(false);

        const inOnboarding = localStorage.getItem("onboardingActive") === "true";
        if (inOnboarding) {
          localStorage.setItem("onboardingStep", "2");
          history.push("/ordem-servicos");
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 422) toast.warn(error.response.data);
        else toast.error("Não foi possível adicionar serviço");
      });
  }

  return (
    <div>
      {/* Botão flutuante padronizado */}
      <button 
        onClick={() => setIsOpen(true)} 
        type="button"
        className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center onboarding-pulse shadow"
        style={{ width: '54px', height: '54px', minWidth: '54px' }}
        title="Cadastrar Novo Serviço"
      >
        <i className="fa fa-plus fs-5"></i>
      </button>

          <Modal
            isOpen={isOpen}
            toggle={() => setIsOpen(false)}
            backdrop="static"
            size="lg"
            centered
          >
            {/* Cabeçalho Limpo (Título em Preto) */}
            <ModalHeader toggle={toggle} wrapTag="div" 
            className="border-0 pb-0 pt-4 px-4 d-flex align-items-start">
              <h5 className="fw-bold text-dark mb-0">Novo Serviço</h5>
              <p className="text-muted small mb-0 mt-1">Cadastre rapidamente um novo serviço</p>
            </ModalHeader>

            <form onSubmit={handleSubmit}>
              <ModalBody className="px-4 pt-3 pb-4">
                
                {/* SEÇÃO ÚNICA: DADOS DO SERVIÇO (CARD LIGHT) */}
                <div className="bg-light p-3 rounded-4 border mb-2">
                  <div className="d-flex align-items-center mb-3 text-primary">
                    <i className="fas fa-tags me-2"></i>
                    <span className="fw-bold text-muted small text-uppercase" style={{ fontSize: '0.72rem' }}>
                      Informações Básicas
                    </span>
                  </div>

                  <div className="row g-3">
                    {/* Nome do Serviço ocupando a maior parte */}
                    <div className="col-lg-8 col-md-12">
                      <label htmlFor="serviceName" className="form-label small fw-bold text-dark mb-2">
                        Nome do Serviço
                      </label>
                      <input
                        ref={inputName}
                        type="text"
                        id="serviceName"
                        placeholder="Ex: Lavagem Simples"
                        className="form-control form-control-lg fs-6 rounded-3 border-2"
                        required
                        autoFocus
                      />
                    </div>

                    {/* Preço de venda ao lado */}
                    <div className="col-lg-4 col-md-12">
                      <label htmlFor="preco" className="form-label small fw-bold text-dark mb-2">
                        Preço (R$)
                      </label>
                      <input
                        ref={inputPrice}
                        id="preco"
                        type="number"
                        inputMode="decimal"
                        min={0}
                        step={0.01}
                        placeholder="0.00"
                        className="form-control form-control-lg fs-6 rounded-3 border-2 fw-bold text-primary"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Bloco de Remarketing oculto por padrão (d-none) */}
                <div className="col-lg-12 mt-3 d-none">
                  <div className="form-check form-switch">
                    <input
                      checked={remarketing}
                      onChange={() => setRemarketing(!remarketing)}
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                    />
                    <label className="form-check-label fw-bold text-dark" htmlFor="flexSwitchCheckDefault">
                      Remarketing Automático
                    </label>
                  </div>
                </div>

              </ModalBody>

              {/* Rodapé Padronizado */}
              <ModalFooter className="border-0 pt-2 px-4 pb-4">
                {!loading ? (
                  <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end">
                    <button
                      type="button"
                      onClick={() => setIsOpen(false)}
                      className="btn btn-outline-secondary btn-lg fw-bold rounded-3 px-4 order-1 order-sm-0"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm px-4"
                      style={{ minWidth: '160px' }}
                    >
                      <i className="fas fa-save me-2"></i>
                      Salvar
                    </button>
                  </div>
                ) : (
                  <div className="w-100 text-center py-2">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Salvando...</span>
                    </div>
                  </div>
                )}
              </ModalFooter>
            </form>
          </Modal>
        </div>
      );
    };

    export default ServicoForm;